import { render, staticRenderFns } from "./PhenologicalStageTracking.vue?vue&type=template&id=48ed1b70&scoped=true&lang=html&"
import script from "./PhenologicalStageTracking.vue?vue&type=script&lang=js&"
export * from "./PhenologicalStageTracking.vue?vue&type=script&lang=js&"
import style0 from "./PhenologicalStageTracking.vue?vue&type=style&index=0&id=48ed1b70&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed1b70",
  null
  
)

export default component.exports